import { updateBoothURL } from "./updateBoothURL";
import { IBooth } from "../store/interfaces/IBooth";

export const findBoothIndex = (
  booth: string,
  booths: IBooth[],
  direction: string
) => {
  if (!booth || booths.length < 1 || !direction) return;
  let boothIndex = Number(booth.split("-")[1][1]);
  const splitName = booth.split("-")[1];
  const splitHall = booth.split("-")[0];
  const boothColumn = splitName[0]?.charCodeAt(0);
  const characterPositionInAscii =
    direction === "left" ? boothColumn - 1 : boothColumn + 1;
  let nextOrPreviousColumn = String.fromCharCode(characterPositionInAscii);
  if (nextOrPreviousColumn === "D") {
    boothIndex = Number(splitName[1]) + 1;
    nextOrPreviousColumn = "A";
  }
  if (nextOrPreviousColumn === "@") {
    boothIndex = boothIndex - 1;
    nextOrPreviousColumn = "C";
  }
  const boothFound = `${splitHall}-${nextOrPreviousColumn}${boothIndex}`;
  if (boothFound === `${splitHall}-B5` && direction === "right") {
    return `${splitHall}-A6`;
  }
  if (boothFound === `${splitHall}-C5` && direction === "left") {
    return `${splitHall}-A5`;
  }
  if (boothFound === `${splitHall}-B6` && direction === "right") {
    return `${splitHall}-C6`;
  }
  if (boothFound === `${splitHall}-B6` && direction === "left") {
    return `${splitHall}-A6`;
  }
  if (boothFound === `${splitHall}-A7` && direction === "right") {
    return `${splitHall}-C5`;
  }
  if (boothFound === `${splitHall}-A6` && direction === "right") {
    return undefined;
  }
  if (boothFound === `${splitHall}-B5` && direction === "left") {
    return `${splitHall}-C6`;
  }
  for (let i = 0; i < booths.length; i++) {
    if (boothFound === booths[i].name.toUpperCase()) {
      return booths[i].name.toUpperCase();
    }
  }
};

export const updateNextAndPreviousBoothURL = (
  booth: string,
  booths: IBooth[],
  direction: string
) => {
  if (!booth || booths.length < 1 || !direction) return;
  const boothFound = findBoothIndex(booth, booths, direction);
  if (!boothFound) return;
  updateBoothURL(null, boothFound);
};
